export const palette = {
  primary: {
    main: "#01AFAE",
    light: "#4ECDC4",
    dark: "#0F2027",
    icon: "#4ECDC4",
    button: "#FFC34B",
    contrastText: "#ffffff",
    focus: "#aad4d8",
  },
  secondary: {
    main: "#FFC34B",
    contrastText: "#01AFAE",
    light: "#FFF9E5"
  },
  information: {
    main: "#ffffff",
    button: "#252118A6"
  },
  error: {
    main: "#C62828",
    light: "#E53935",
    dark: "#B71C1C",
  },
  warning: {
    main: "#F65835",
    light: "#FF9800",
    dark: "#FF6F00",
  },
  info: {
    main: "#02A1FF",
    light: "#64C2FF",
    dark: "#007AC1",
  },
  success: {
    main: "#2E7D32",
    light: "#4CAF50",
    dark: "#1B5E20",
  },
  text: {
    primary: "#000000",
    secondary: "#5f686e",
    disabled: "#90A4AE",
    action: "#01868D",
    typo: "#FFC34B",
  },
  background: {
    default: "#01AFAE",
    paper: "#ffffff",
    disabled: "#7E7C7C",
  },
};
